<template>
    <vPartnerCurrentComponent :postList="postList" v-if="flag"></vPartnerCurrentComponent>
</template>
<script>
import vPartnerCurrentComponent from '../../listComponent/basicdata/partnerCurrent/partnerCurrentComponent.vue';
export default {
    name: 'partnerCurrent',
    components: {
        vPartnerCurrentComponent
    },
    data() {
        return {
            postList: {
                headerTitle: false,
                // addBtn: true,
                searchBtn: true,
                resetBtn: true,
                downFileBtn: true,
                setBtn: true,
                partner_rid: true,
                product_rid: true,
                period: true,
                type: true,
                feature_code: true
            },
            flag: false
        };
    },
    mounted() {
        this.$nextTick(() => {
            this.flag = true;
        });
    },
    methods: {}
};
</script>
<style lang="scss" scoped="scoped">
</style>